import Customers from './Customers'
export default Customers
